<template>
  <div class="copyright">
    <img v-if="!isWhite" class="copyright-image" src="@/assets/copyright_b.png"/>
    <img v-else class="copyright-image" src="@/assets/copyright_w.png"/>
    <p class="copyright-text" v-bind:class="{ 'copyright-text-white': isWhite }">aeka corporation</p>
  </div>
</template>

<script>
export default {
  name: 'Brands',
  props: {
    isWhite: Boolean
  }
}
</script>

<style scoped>
.copyright {
  display: flex;
  align-items: center;
  padding: 0 48px 32px 0;
  transform: scale(0.8);
  transform-origin: right;
}
.copyright-text {
  font-size: 12px;
  letter-spacing: 1px;
  color: #000;
}
.copyright-text-white {
  color: #fff;
}
.copyright-image {
  width: 10px;
  height: 10px;
  padding-right: 4px;
}
@media (max-width: 639px) {
  .copyright {
    padding: 0 32px 16px 0;
  }
  .copyright-text {
    font-size: 9px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/modules/Copyright.vue